import type { PrincipleId } from './principlesData';

export default function PrincipleIcon({ kind }: { kind: PrincipleId }) {
  const common = {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    'aria-hidden': true as const,
  };
  const navy = '#112866';
  const gold = '#c9a227';

  if (kind === 'charity') {
    return (
      <svg {...common}>
        <path
          d="M24 40s-14-8.5-14-18a8 8 0 0 1 14-5.3A8 8 0 0 1 38 22c0 9.5-14 18-14 18z"
          stroke={navy}
          strokeWidth="2.2"
          fill={gold}
          fillOpacity="0.25"
        />
      </svg>
    );
  }
  if (kind === 'unity') {
    return (
      <svg {...common}>
        <circle cx="18" cy="24" r="9" stroke={navy} strokeWidth="2.2" />
        <circle cx="30" cy="24" r="9" stroke={gold} strokeWidth="2.2" />
      </svg>
    );
  }
  if (kind === 'fraternity') {
    return (
      <svg {...common}>
        <circle cx="16" cy="16" r="6" stroke={navy} strokeWidth="2.2" />
        <circle cx="32" cy="16" r="6" stroke={navy} strokeWidth="2.2" />
        <path
          d="M8 38c1.5-7 6-11 8-11s5 2 8 2 6-2 8-2 6.5 4 8 11"
          stroke={gold}
          strokeWidth="2.2"
          strokeLinecap="round"
        />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <path d="M10 38V12l18-4v30" stroke={navy} strokeWidth="2.2" strokeLinejoin="round" />
      <path d="M10 12h18" stroke={gold} strokeWidth="2.2" />
      <path d="M28 14l10 3v12l-10 3V14z" stroke={navy} strokeWidth="2.2" fill={gold} fillOpacity="0.3" />
    </svg>
  );
}